import styled from 'styled-components';

import { FlexCenter } from 'src/client/components';

import DragAndDropArea from '../DragAndDropArea';

export const StyledDragAndDropArea = styled(DragAndDropArea)``;

export const UnfeaturedCardsContainer = styled(FlexCenter)``;
